import {
  QualAnalysisTheme,
  QualAnalysisThemeVariantShare,
} from './renderer-internal-types'

export interface QualThemeIncidenceVariant {
  variantId: string
  label: string
}

/**
 * The slice of a theme the incidence helpers actually read. Typed this narrowly
 * so the results page (`QuestionCard`) can hand over its own theme summary
 * items, which carry `variantShares` under a different card shape.
 */
export type ThemeWithIncidence = Pick<QualAnalysisTheme, 'variantShares'>

export function themeHasIncidence(theme: ThemeWithIncidence): boolean {
  return Array.isArray(theme.variantShares) && theme.variantShares.length > 0
}

export function collectIncidenceVariants(
  themes: Array<ThemeWithIncidence>,
): Array<QualThemeIncidenceVariant> {
  const variants: Array<QualThemeIncidenceVariant> = []
  const seen = new Set<string>()

  for (const theme of themes) {
    if (!themeHasIncidence(theme) || !theme.variantShares) {
      continue
    }

    for (const share of theme.variantShares) {
      const variantId = (share.variantId || '').trim()
      if (!variantId || seen.has(variantId)) {
        continue
      }

      seen.add(variantId)
      const label = (share.label || '').trim() || variantId
      variants.push({ variantId, label })
    }
  }

  return variants
}

export function formatIncidenceCell(
  share: QualAnalysisThemeVariantShare | undefined,
): string {
  if (!share) {
    return '0%'
  }

  if (typeof share.percent === 'number' && Number.isFinite(share.percent)) {
    return `${Math.round(share.percent)}%`
  }

  if (typeof share.frequency === 'number' && Number.isFinite(share.frequency)) {
    return String(share.frequency)
  }

  return '0%'
}
